module.exports = __webpack_public_path__ + "img/00042.77e8b91d.webp";